export default __webpack_public_path__ + "static/media/layers_alt.54aa9718.svg";